import getFlipperService from './get-flipper-service';
import configStore from '../config-store';

export default getFlipperService(configStore);
